import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../core/winpresentation/SimplePresentationRunner";
import {Game} from "../Game";
import {gsap} from "gsap";
import {GameFeatureMode} from "../enums/Enum";

export class UpgradeRunner implements SimplePresentation {
    shouldRun(): boolean {
        return Game.model.isFSUpgrade() || Game.model.isCFSUpgrade();
    }

    start(controller: SimplePresentationRunnerController): void {
        const tl: gsap.core.Timeline = new gsap.core.Timeline();
        tl.add(() => {
            Game.foregroundElements.playReelSetFlicker();
        });
        tl.add(() => {
            Game.foregroundElements.stopReelSetFlicker();
        }, 0.3);

        tl.add(() => {
            Game.keypadPlugin.setZeroBetSpinCounter(-1);
        })
        tl.add(Game.upgradeView.show(Game.model.data.nextMode as GameFeatureMode));
        tl.add(() => {
            controller.setSkipCallback(() => {
                tl.progress(1);
            });
        });
        tl.add(Game.upgradeView.playLift(Game.model.data.nextMode as GameFeatureMode));
        tl.add(Game.reelView.show());
        tl.add(() => {
            Game.keypadPlugin.setZeroBetSpinCounter(Game.model.data.freespinsLeft);
            controller.finish();
        })
    }

}